import './index.scss'
export { Search, Search as default } from 'carbon-components-react'
